"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var PropTypes = React.PropTypes;

var TabsPanel = function (_React$Component) {
  _inherits(TabsPanel, _React$Component);

  function TabsPanel() {
    _classCallCheck(this, TabsPanel);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  TabsPanel.prototype.render = function render() {
    var selected = this.context.activeTab === this.props.id;

    return React.createElement(
      "div",
      {
        className: "cf-tabs__panel",
        role: "tabpanel",
        "aria-labelledby": this.props.id,
        "aria-hidden": !selected,
        style: { display: selected ? 'block' : 'none' } },
      this.props.children
    );
  };

  return TabsPanel;
}(React.Component);

TabsPanel.propTypes = {
  id: PropTypes.string.isRequired
};
TabsPanel.contextTypes = {
  activeTab: PropTypes.string.isRequired
};


module.exports = TabsPanel;